import deepmerge from "../Deepmerge";

import enUS from "./translations/en-US";

class LexiconManager {

	constructor(){
		this.lexicons = {};
	}

	addLexicon(langCode,newLexi){
		this.lexicons[langCode] = deepmerge(enUS,newLexi);
	}

	removeLexicon(langCode){
		delete this.lexicons[langCode];
	}

	getLexicon(lang="en-US",overwrite = {}) {
		if(!Object.prototype.hasOwnProperty.call(this.lexicons,lang)){
			lang = "en-US";
		}
		return { ...this.lexicons[lang], ...overwrite };
	}

}

const lexiMan = new LexiconManager();

lexiMan.addLexicon("en-US",enUS);

export default lexiMan;